import styled from '@emotion/styled';

export const Title = styled.div`
  font-family: NokiaPureText-Bold;
  font-size: 30px;
  color: ${({ theme }) => theme.colors.blueBlack};
`;

export const SendBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 39px;
  width: 100%;
`;
